/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */

import React, { FC } from "react";

import { brokerApi } from "@/shared/apis";
import { UrlManager } from "@/shared/apis/UrlManager";
import { useAuth } from "@/shared/hooks";

import { StyledBrokerHeader } from "./styled";

const AuthenticatedBrokerHeader: FC = () => {
    const { user } = useAuth();

    const {
        data: { result: availableBrokers },
    } = brokerApi.useQueryBrokers();

    const currentStateBroker = availableBrokers.find((item) => item.officeId === user.currentBrokerId);

    const handleClickAddress = () => {
        window.open(`https://maps.google.com/?q=${currentStateBroker.address} ${currentStateBroker.zipCode}`, "_blank");
    };
    const handleClickPhone = () => {
        window.location.assign(`tel:${currentStateBroker.phone}`);
    };

    const handleClickEmail = () => {
        window.location.assign(`mailto:${currentStateBroker.email}`);
    };

    const handleClickUrl = () => {
        window.open(currentStateBroker.url, "_blank");
    };

    // TODO: Refacor this component to use MUI components/styled components

    return (
        <StyledBrokerHeader>
            <div className="broker-header-content">
                {currentStateBroker?.officeId && (
                    <img className="broker-image" alt="" src={UrlManager.brokerLogo(currentStateBroker?.officeId)} />
                )}

                <div className="infos-flex-list">
                    <ul>
                        {currentStateBroker?.address && (
                            <li className="broker-info-item" onClick={handleClickAddress}>
                                {currentStateBroker?.address} {currentStateBroker?.zipCode} {currentStateBroker?.city}
                            </li>
                        )}
                        {currentStateBroker?.phone && (
                            <li className="broker-info-item" onClick={handleClickPhone}>
                                {currentStateBroker?.phone}
                            </li>
                        )}
                        {currentStateBroker?.email && (
                            <li className="broker-info-item" onClick={handleClickEmail}>
                                {currentStateBroker?.email}
                            </li>
                        )}
                        {currentStateBroker?.url && (
                            <li className="broker-info-item" onClick={handleClickUrl}>
                                {currentStateBroker?.url}
                            </li>
                        )}
                    </ul>
                </div>
            </div>
        </StyledBrokerHeader>
    );
};

export default AuthenticatedBrokerHeader;
